import { render } from "./IntegratedDeviceHeadingLabel.vue?vue&type=template&id=7ef245d8&scoped=true"
import script from "./IntegratedDeviceHeadingLabel.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceHeadingLabel.vue?vue&type=script&lang=js"

import "./IntegratedDeviceHeadingLabel.vue?vue&type=style&index=0&id=7ef245d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef245d8"]])

export default __exports__